import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";

const searchMenuConfigSync = (theme) => ({
  ...selectStyles,
  cardHover: {
    "&:hover": {
      "& $cardHeaderHover": {
        transform: "translate3d(0, -10px, 0)",
      },
    },
  },
  gridNoPadding: {
    padding: "0 !important",
  },
  cardHeader: {
    padding: "10px",
  },
  cardHeaderHover: {
    transition: "all 300ms cubic-bezier(0.34, 1.61, 0.7, 1)",
  },
  cardTitle: {
    margin: "0",
    marginLeft: ".4rem",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",

    fontSize: "1rem",
    display: "inline",
    textDecoration: "none",
  },
  grid: {
    padding: "0 .4rem",
    margin: "0",
    justifyContent: "center",
    width: "100%",
  },
  selectLabel: {
    ...selectStyles.selectLabel,
    color: "#AAAAAA",
    fontSize: "14px",
    marginTop: ".5rem",
    textTransform: "capitalize",
  },
});

export default searchMenuConfigSync;
